import { render, staticRenderFns } from "./AtAGlanceTab.vue?vue&type=template&id=1a99c9ba&scoped=true"
import script from "./AtAGlanceTab.vue?vue&type=script&lang=ts"
export * from "./AtAGlanceTab.vue?vue&type=script&lang=ts"
import style0 from "./AtAGlanceTab.vue?vue&type=style&index=0&id=1a99c9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a99c9ba",
  null
  
)

export default component.exports